module.exports = __webpack_public_path__ + "static/img/202409.5c79f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202409.png
// module id = iVlz
// module chunks = 0